import c from "html-react-parser";
import "@adobe/aem-spa-page-model-manager";
import { s as i } from "./sanitizeHtml-95395ce0.js";
const s = (r = "", t = {}) => {
  try {
    return new Function(...Object.keys(t), `return \`${r}\`;`)(...Object.values(t));
  } catch (e) {
    return console.error(e), r;
  }
}, a = (r = "", t = {}) => {
  if (!Object.keys(t).length)
    return r;
  try {
    return Object.keys(t).reduce((e, n) => e.replaceAll(`{${n}}`, `${t[n]}`), r);
  } catch (e) {
    return console.error(e), r;
  }
}, l = (r = "", t = {}) => {
  var o;
  if (!((o = String(r)) != null && o.trim().length))
    return String(r);
  const e = s(String(r), t);
  return a(e, t);
}, g = (r = "", t) => {
  const e = l(r, t);
  return c(i(e));
};
export {
  l as i,
  g as p
};
